<h1>Hatun Qosqo Map</h1>
<div class="map-container" id="map">
  <span id="btn-toc-map" (click)="toggleTocMap()">{{ viewTocMap === true ? '&laquo;' : '&raquo;' }}</span>
  <div id="layertree" [ngClass]="[ viewTocMap ? 'tocMostrar' : 'tocOcultar']">
    <h5>Capas</h5>
    <ul>
      <li><span>OSM layer</span>
        <fieldset id="layer0">
          <label class="checkbox" for="visible0">
            visible <input id="visible0" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
      </li>
      <li>
        <span>Base</span>
        <fieldset id="layer1">
          <label class="checkbox" for="visible1">
            visible <input id="visible1" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
        <ul>
          <li>
            <span class="item-title">Food insecurity layer</span>
            <fieldset id="layer10">
              <label class="checkbox" for="visible10">
                visible <input id="visible10" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Límite CHC</span>
            <fieldset id="layer11">
              <label class="checkbox" for="visible11">
                <span class="item-label">visible</span> <input id="visible11" class="visible" type="checkbox" />
              </label>
              <label>
                <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                  step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Sectores CHC</span>
            <fieldset id="layer12">
              <label class="checkbox" for="visible12">
                visible <input id="visible11" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Sectores Nombres CHC</span>
            <fieldset id="layer13">
              <label class="checkbox" for="visible13">
                visible <input id="visible11" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Inmuebles</span>
            <fieldset id="layer14">
              <label class="checkbox" for="visible11">
                <span class="item-label">visible</span> <input id="visible11" class="visible" type="checkbox" />
              </label>
              <label>
                <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                  step="0.01" />
              </label>
            </fieldset>
          </li>
        </ul>
      </li>
    </ul>

  </div>
</div>
<div id="popup" class="ol-popup">
  <a href="#" id="popup-closer" class="ol-popup-closer"></a>
  <div id="popup-content"></div>
</div>
<div id="info">&nbsp;</div>
<span class="infini">{{ infi | json}}</span>